import { Card, Label } from 'reactstrap';
import { Plus } from 'react-feather';
import './add-new-credit-card-component.scss';
import 'cleave.js/dist/addons/cleave-phone.us';
import { useTranslation } from 'react-i18next';
import { useOpenOldModal } from '../../../../store/modal/modalHooks';
import { ModalComponentEnum } from '../../../../store/modal/modalTypes';

interface AddNewCreditCardComponentProps {
  onClick?: () => void;
  saveCardValue?: boolean;
  onChangeSaveCard?: (value: boolean) => void;
}

const AddNewCreditCardComponent = (props: AddNewCreditCardComponentProps) => {
  const { t } = useTranslation();
  const openModal = useOpenOldModal();

  const addCreditCard = () => {
    if (props.onClick) {
      props.onClick();
    } else {
      openModal(ModalComponentEnum.ADD_CREDIT_CARD, {
        isFullSizeOnMobile: true,
      });
    }
  };

  return (
    <Card className="add-new-credit-card-component" onClick={addCreditCard}>
      <div className="add-new-credit-card-component-title">
        <Plus size={16} /> <span>{t('ADD_NEW_CREDIT_CARD')}</span>
      </div>
      {props.saveCardValue !== undefined && (
        <div
          className="add-new-credit-card-component-save-card-checkbox"
          onClick={(e) => e.stopPropagation()}
        >
          <Label for="save-card-checkbox">
            <input
              type="checkbox"
              id="save-card-checkbox"
              checked={props.saveCardValue}
              onChange={(e) =>
                props.onChangeSaveCard &&
                props.onChangeSaveCard(e.target.checked)
              }
            />
            {t('SAVE_NEW_CARD')}
          </Label>
        </div>
      )}
    </Card>
  );
};

export default AddNewCreditCardComponent;
